import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_DOMAIN = 'https://grlasaline.fr';

/**
 * Simple page-title + meta description hook (SPA-friendly).
 * Also keeps the canonical <link> tag in sync with the current route.
 * Restores previous values on unmount.
 */
export const usePageMeta = ({ title, description } = {}) => {
  const location = useLocation();

  useEffect(() => {
    const prevTitle = document.title;
    const descTag = document.querySelector('meta[name="description"]');
    const prevDesc = descTag?.getAttribute('content');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const prevOgTitle = ogTitle?.getAttribute('content');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    const prevOgDesc = ogDesc?.getAttribute('content');
    const canonicalTag = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonicalTag?.getAttribute('href');

    if (title) {
      document.title = title;
      if (ogTitle) ogTitle.setAttribute('content', title);
    }
    if (description) {
      if (descTag) descTag.setAttribute('content', description);
      if (ogDesc) ogDesc.setAttribute('content', description);
    }
    if (canonicalTag) {
      const path = location.pathname === '/' ? '/' : `${location.pathname.replace(/\/$/, '')}`;
      canonicalTag.setAttribute('href', `${SITE_DOMAIN}${path}`);
    }
    return () => {
      document.title = prevTitle;
      if (descTag && prevDesc != null) descTag.setAttribute('content', prevDesc);
      if (ogTitle && prevOgTitle != null) ogTitle.setAttribute('content', prevOgTitle);
      if (ogDesc && prevOgDesc != null) ogDesc.setAttribute('content', prevOgDesc);
      if (canonicalTag && prevCanonical != null) canonicalTag.setAttribute('href', prevCanonical);
    };
  }, [title, description, location.pathname]);
};
